<toggler
  data-qa="dashboard.account-swap-free.toggle"
  [checked]="!!(isChecked$ | async)"
  [disabled]="!!(isDisabled$ | async)"
  [loading]="!!(isLoading$ | async)"
  (changed)="toggleSwapFree()"
/>
